// extracted by mini-css-extract-plugin
export default {"buttons-container":"EmailCheckFailed_buttons-container__xUAEv","align-center":"EmailCheckFailed_align-center__pqHC4","contacts":"EmailCheckFailed_contacts__OJdk8"};